import YearsRequest from '../ws/YearsRequest';
import MonthsRequest from '../ws/MonthsRequest';
import WorkCheckStatesRequest from '../ws/WorkCheckStatesRequest';
import WorkChecksTypesRequest from '../ws/WorkChecksTypesRequest';
import SaveWorkChecksTypesRequest from '../ws/SaveWorkChecksTypesRequest';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import SaveWorkChecksTypesBatchRequest from '../ws/SaveWorkChecksTypesBatchRequest';
import { WorkChecksRequest } from '../../../shared/work-checks/work-checks-list/WorkChecksRequest';
import { WorkChecksTask } from '../../../shared/work-checks/work-checks-list/WorkChecksTask';

export const MONTHLY_YEARS_UPDATE = 'monthly-years-update';
export const MONTHLY_MONTHS_UPDATE = 'monthly-months-update';
export const MONTHLY_WORK_CHECK_STATES_UPDATE = 'monthly-work-check-states-update';
export const MONTHLY_WORK_CHECK_TYPES_UPDATE = 'monthly-work-check-types-update';

export const MONTHLY_WORK_CHECK_UPDATE = 'monthly-work-check-update';
export const MONTHLY_WORK_CHECK_SORT = 'monthly-work-check-sort';
export const MONTHLY_WORK_CHECK_CLEAR = 'monthly-work-check-clear';
export const MONTHLY_WORK_CHECK_LOADING = 'monthly-work-check-loading';
export const MONTHLY_WORK_CHECK_ERROR = 'monthly-work-check-error';

export const MONTHLY_WORK_STATE_MONTH_UPDATE = 'monthly-work-state-month-update';

export const getWorkCheckStates = () => (dispatch) => {

    new WorkCheckStatesRequest()
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_WORK_CHECK_STATES_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const getWorkCheckTypes = (constructionId, year, month, companyId) => (dispatch) => {

    new WorkChecksTypesRequest(constructionId, year, month, companyId)
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_WORK_CHECK_TYPES_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const getYears = (constructionId) => (dispatch) => {

    new YearsRequest(constructionId)
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_YEARS_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const getMonths = (constructionId, year) => (dispatch) => {

    new MonthsRequest(constructionId, year)
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_MONTHS_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const getWorkChecks = (
    constructionId,
    year,
    month,
    companyId,
    term = '',
    page = 1,
    sort,
) => (dispatch) => {
    const request = new WorkChecksRequest();
    request.setConstructionId(constructionId);
    request.setYear(year);
    request.setMonth(month);
    request.setCompanyId(companyId);
    request.setTerm(term);
    request.setPage(page);

    new WorkChecksTask(request)
        .onSuccess(response => {
            // Enviamos los datos a redux junto con sort
            dispatch({
                type: MONTHLY_WORK_CHECK_UPDATE,
                payload: {
                    ...response,
                    sort,
                },
            });
        })
        .onFail(error => {
            dispatch({ type: MONTHLY_WORK_CHECK_ERROR, payload: error });
        })
        .onPreExecution(() => {
            dispatch({ type: MONTHLY_WORK_CHECK_LOADING, payload: true });
        })
        .onPostExecution(() => {
            dispatch({ type: MONTHLY_WORK_CHECK_LOADING, payload: false });
        })
        .execute();
};

export const sortWorkChecks = (orderBy) => ( {
    type: MONTHLY_WORK_CHECK_SORT,
    payload: orderBy,
} );

export const clearWorkChecks = () => ( {
    type: MONTHLY_WORK_CHECK_CLEAR,
} );

export const saveWorkCheckType = (constructionId, year, month, companyId, workerId, workerCheckTypeId, workerCheckStateId) => (dispatch) => {

    new SaveWorkChecksTypesRequest(constructionId, year, month, companyId, workerId, workerCheckTypeId, workerCheckStateId)
        .onPreExecution(() => {
            const payload = {
                id: -1,
                document_type_id: workerCheckTypeId,
                worker_check_state_id: parseInt(workerCheckStateId, 10),
            };
            dispatch({ type: MONTHLY_WORK_STATE_MONTH_UPDATE, workerId: workerId, payload: payload });
        })
        .onSuccess(response => {
        })
        .onFail(error => {
            Alert.error(I18nUtils.tr('TR_ERROR_MODIFICANDO_ESTADO'));
        })
        .execute();
};

export const saveWorkCheckTypeBatch = (constructionId, year, month, companyId, workerIds, workerCheckTypeId, workerCheckStateId) => (dispatch) => {

    new SaveWorkChecksTypesBatchRequest(constructionId, year, month, companyId, workerIds, workerCheckTypeId, workerCheckStateId)
        .onPreExecution(() => {
            const payload = {
                id: -1,
                document_type_id: workerCheckTypeId,
                worker_check_state_id: parseInt(workerCheckStateId, 10),
            };
            workerIds.forEach((workerId) => {
                dispatch({ type: MONTHLY_WORK_STATE_MONTH_UPDATE, workerId: workerId, payload: payload });
            });
        })
        .onSuccess(response => {
        })
        .onFail(error => {
            Alert.error(I18nUtils.tr('TR_ERROR_MODIFICANDO_ESTADO'));
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/actions/monthlyActions.js